import { render, staticRenderFns } from "./SubastaModalCorreo.vue?vue&type=template&id=2c318f89"
import script from "./SubastaModalCorreo.vue?vue&type=script&lang=js"
export * from "./SubastaModalCorreo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports